import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "card-header text-center" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "price"
}
const _hoisted_6 = {
  key: 1,
  class: "card-body"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 1,
  class: "included-options-heading"
}
const _hoisted_9 = {
  key: 2,
  class: "list-group list-group-flush included-options"
}
const _hoisted_10 = { class: "included-option" }
const _hoisted_11 = ["data-bs-content"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  "aria-label": "Weitere Information",
  class: "fal far fas fa-question-circle info-icon"
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_image_top = _resolveComponent("card-image-top")!

  return (_openBlock(), _createElementBlock("a", {
    id: `segment-${_ctx.segment.alias}`,
    class: _normalizeClass(['card card--path-segment package', { 'recommended': _ctx.segment.recommended, 'card--selected': _ctx.segment.chosen }]),
    href: "#",
    title: "Auswählen",
    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)), ["stop","prevent"]))
  }, [
    (_ctx.segment.icon || _ctx.segment.image)
      ? (_openBlock(), _createBlock(_component_card_image_top, {
          key: 0,
          icon: _ctx.segment.icon,
          image: _ctx.segment.image
        }, null, 8, ["icon", "image"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "card-title",
        innerHTML: _ctx.decodeHtmlEntities(_ctx.segment.title)
      }, null, 8, _hoisted_3),
      (_ctx.segment.showPrice)
        ? (_openBlock(), _createElementBlock("br", _hoisted_4))
        : _createCommentVNode("", true),
      (_ctx.segment.showPrice)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.displayPrice), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.segment.description || _ctx.segment.options.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.segment.description)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: "description",
                innerHTML: _ctx.decodeHtmlEntities(_ctx.segment.description)
              }, null, 8, _hoisted_7))
            : _createCommentVNode("", true),
          (_ctx.segment.options && _ctx.segment.options.length > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Enthaltene Leistungen:"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.segment.options && _ctx.segment.options.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.segment.options, (includedOption) => {
            return (_openBlock(), _createElementBlock("li", {
              key: includedOption.id,
              class: "list-group-item"
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", null, _toDisplayString(_ctx.decodeHtmlEntities(includedOption.title)), 1),
                (includedOption.description)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "included-option__info",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop","prevent"]))
                    }, [
                      _createElementVNode("a", {
                        "data-bs-content": _ctx.decodeHtmlEntities(includedOption.description),
                        "data-bs-toggle": "popover",
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"]))
                      }, _hoisted_13, 8, _hoisted_11)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}